import { useAuth } from '../hooks/useAuth'

/** Rare fallback when Firebase session exists but email is not verified. */
export function VerifyEmailPage() {
  const { user, signOutUser } = useAuth()

  return (
    <div className="shell login-shell">
      <header className="top compact">
        <div className="brand">
          <span className="mark">BeyondQuota</span>
          <h1>Verify your email</h1>
        </div>
        <p className="lede tight">
          Your session for{' '}
          <span className="auth-email">{user?.email ?? 'this account'}</span> is not verified.
          Request a new sign-in link from the login page.
        </p>
      </header>

      <div className="login-card">
        <button type="button" className="login-primary" onClick={() => void signOutUser()}>
          Back to sign in
        </button>
      </div>
    </div>
  )
}
